import type { ProductExportAttrColumn } from '@/services/product.service';

export type { ProductExportAttrColumn as AttrColumn };

export function formatSaleType(saleType: unknown): string {
  const types = Array.isArray(saleType) ? saleType : [saleType];
  return types
    .map((t) => (t === 'ONLINE' ? 'Online' : t === 'STORE' ? 'Tại quầy' : String(t ?? '')))
    .join(', ');
}

export function formatState(state: unknown): string {
  if (state === 1) return 'Hiển thị';
  if (state === 0) return 'Nháp';
  return 'Ẩn';
}

export function formatPricingModel(model?: unknown): string {
  const map: Record<string, string> = {
    FIXED: 'Giá cố định',
    DYNAMIC_MARKET: 'Theo thị trường',
    DYNAMIC_SERIAL_WEIGHT: 'Theo cân nặng',
  };
  return map[String(model ?? '')] ?? String(model ?? '');
}

export function buildExportRows(
  products: Array<Record<string, unknown>>,
  variantsByProduct: Record<string, Array<Record<string, unknown>>>,
  attrColumns: ProductExportAttrColumn[],
): Array<Array<unknown>> {
  let stt = 0;
  const rows: Array<Array<unknown>> = [];

  for (const product of products) {
    const productId = String(product['_id'] ?? '');
    const variants = variantsByProduct[productId] ?? [];

    const categoryIds = Array.isArray(product['category_id']) ? product['category_id'] : [];
    const categories = categoryIds
      .map((c) => (typeof c === 'object' && c !== null ? (c as Record<string, unknown>)['name'] : c))
      .join(', ');

    const brand = typeof product['brand_id'] === 'object' && product['brand_id'] !== null
      ? (product['brand_id'] as Record<string, unknown>)['name'] ?? ''
      : '';

    const variantList = variants.length > 0 ? variants : [null];

    for (const variant of variantList) {
      stt++;
      const attrs = variant !== null
        ? (variant['attrs'] as Record<string, unknown> | undefined)
        : undefined;

      rows.push([
        stt,
        product['name'] ?? '',
        product['show_name'] ?? '',
        product['sku'] ?? '',
        categories,
        brand,
        formatSaleType(product['sale_type']),
        formatState(product['state']),
        product['tracking_mode'] === 'serial' ? 'Mã quy cách' : 'Số lượng',
        variant?.['variant_code'] ?? '',
        formatPricingModel(variant?.['pricing_model']),
        variant?.['cached_price'] ?? 0,
        variant?.['is_sellable'] !== false ? 'Có' : 'Không',
        variant?.['is_published'] !== false ? 'Có' : 'Không',
        ...attrColumns.map((a) => {
          const raw = attrs?.[a.code];
          if (raw === undefined || raw === null || raw === '') return '';
          if (a.data_type === 'enum' && a.enumLabels) {
            return a.enumLabels[String(raw)] ?? raw;
          }
          return raw;
        }),
      ]);
    }
  }

  return rows;
}
